export const isMobile = () => {
    const MOBILE_WIDTH = 600;
    return window.innerWidth < MOBILE_WIDTH;
}